import { render } from "./index.vue?vue&type=template&id=35e16627&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=35e16627&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/myjq-pc-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e16627"]])

export default __exports__